import { render, staticRenderFns } from "./guangzhou.vue?vue&type=template&id=54fac096&scoped=true"
import script from "./guangzhou.vue?vue&type=script&lang=js"
export * from "./guangzhou.vue?vue&type=script&lang=js"
import style0 from "./guangzhou.vue?vue&type=style&index=0&id=54fac096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fac096",
  null
  
)

export default component.exports